export function getConfigString(key: string) {
  const podName = process.env.REACT_APP_POD_NAME;
  const value = `${process.env[key]}`;

  if (podName === 'partner') {
    const {
      location: { hostname },
    } = window;
    const partnerNameList = process.env.REACT_APP_PARTNER_NAME_LIST?.split(',') || [];
    const domainPartner = partnerNameList.find((partnerName) => hostname.includes(partnerName));
    const partnerValue = domainPartner && value.replaceAll('partner', domainPartner);
    const isLocalHost = hostname.includes('localhost');
    const localHostValue = value.replaceAll('partner', 'red');

    return isLocalHost ? localHostValue : partnerValue;
  }

  return value;
}

export function getConfigNumber(key: string) {
  const value = getConfigString(key);
  return value ? parseInt(value, 10) : undefined;
}

export function getConfigBoolean(key: string) {
  const value = getConfigString(key);
  return value === 'true';
}

export function getAppPrefix() {
  return getConfigString('REACT_APP_PREFIX');
}

export function isPatientApp() {
  return getAppPrefix() === 'lh_patient';
}

export function getApiBasePath() {
  return isPatientApp() ? getConfigString('REACT_APP_API_PATIENT') : getConfigString('REACT_APP_API_BASE');
}

export function getApiGraphQLPath() {
  return getConfigString('REACT_APP_API_GRAPHQL');
}

export function getApiEmbeddedPath() {
  return getConfigString('REACT_APP_API_EMBEDDED');
}

export function getApiSocketPath() {
  return getConfigString('REACT_APP_API_SOCKET');
}

export function getSitePatient() {
  return getConfigString('REACT_APP_SITE_PATIENT');
}

export function getSiteNextyPatient() {
  return getConfigString('REACT_APP_SITE_NEXTY_PATIENT');
}

export function getSiteWidgets() {
  return getConfigString('REACT_APP_SITE_WIDGETS');
}

export function getSiteSso() {
  return getConfigString('REACT_APP_SITE_SSO');
}

export function getGtmId() {
  return getConfigString('REACT_APP_GTM_ID');
}

export function getGtmIdAdditional() {
  return getConfigString('REACT_APP_GTM_ID_ADDITIONAL');
}

export function getCommitHash() {
  return getConfigString('REACT_APP_COMMIT_HASH');
}

export function getKeyGooglMaps() {
  return getConfigString('REACT_APP_GOOGL_KEY_MAPS');
}

export function getKeyZendesk() {
  return getConfigString('REACT_APP_ZENDESK_KEY');
}

export function getKeyRecaptcha() {
  return getConfigString('REACT_APP_RECAPTCHA_ID');
}

export function getSessionExpireMinutes() {
  return getConfigNumber('REACT_APP_SESSION_EXPIRE_MINUTES') as number;
}

export function isI18nEnabled() {
  return getConfigBoolean('REACT_APP_I18N_ENABLED');
}

export function getPodName() {
  return getConfigString('REACT_APP_POD_NAME');
}

export function getSiteNext() {
  return getConfigString('REACT_APP_SITE_NEXT');
}

export function getLookerUrl() {
  return getConfigString('REACT_APP_LOOKER_URL');
}

export function getBroadcastInvalidTerms() {
  return getConfigString('REACT_APP_BROADCAST_INVALIDTERMS');
}

export function getBroadcastOffensiveWords() {
  return getConfigString('REACT_APP_BROADCAST_OFFENSIVEWORDS');
}

export function getFilesAccept() {
  return getConfigString('REACT_APP_FILES_ACCEPT');
}

export function getGooglKeyMaps() {
  return getConfigString('REACT_APP_GOOGL_KEY_MAPS');
}

export function getRecaptchaId() {
  return getConfigString('REACT_APP_RECAPTCHA_ID');
}

export function getWebPasswordMinimumLength() {
  return getConfigString('REACT_APP_WEB_PASSWORD_MINIMUM_LENGTH');
}

export function getDatadogApplicationId() {
  return getConfigString('REACT_APP_DATADOG_APPLICATION_ID');
}

export function getDatadogClientToken() {
  return getConfigString('REACT_APP_DATADOG_CLIENT_TOKEN');
}

export function getFullstoryId() {
  return getConfigString('REACT_APP_FULLSTORY_ID');
}

export function getResellerPartners() {
  return getConfigString('REACT_APP_RESELLER_PARTNERS');
}

// TODO: Skip default-exporting objects
export default {
  getAppPrefix,
  getApiBasePath,
  getApiGraphQLPath,
  getApiEmbeddedPath,
  getApiSocketPath,
  getSitePatient,
  getSiteNextyPatient,
  getSiteWidgets,
  getSiteSso,
  getGtmId,
  getGtmIdAdditional,
  getCommitHash,
  getKeyGooglMaps,
  getKeyZendesk,
  getKeyRecaptcha,
  getSessionExpireMinutes,
  isPatientApp,
  isI18nEnabled,
  getPodName,
  getSiteNext,
  getLookerUrl,
  getBroadcastInvalidTerms,
  getBroadcastOffensiveWords,
  getFilesAccept,
  getGooglKeyMaps,
  getRecaptchaId,
  getWebPasswordMinimumLength,
  getDatadogApplicationId,
  getDatadogClientToken,
  getFullstoryId,
  getResellerPartners,
};
